'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cellSizes = function cellSizes(key, defaultValue) {
	return [{
		label: 'Cell size desktop',
		name: 'desktopSize_' + key,
		inputType: 'select',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden'],
		default: defaultValue || '2of12'
	}, {
		label: 'Cell size tablet',
		name: 'tabletSize_' + key,
		inputType: 'select',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden'],
		default: defaultValue || '2of12'
	}, {
		label: 'Cell size mobile',
		name: 'mobileSize_' + key,
		inputType: 'select',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden'],
		default: defaultValue || '2of12'
	}];
};

var getField = function getField(key, label, headingDefault, sort, sizeDefault) {
	var show = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	return {
		label: label,
		props: [{
			label: 'Show',
			name: key + 'Show',
			inputType: 'checkbox',
			default: show
		}, {
			label: 'Heading',
			name: key + 'Heading',
			inputType: 'text',
			default: headingDefault
		}, {
			label: 'Sort',
			name: key + 'Sort',
			inputType: 'number',
			default: sort
		}, {
			label: 'Align',
			name: key + 'Align',
			inputType: 'select',
			values: [{
				label: 'Left',
				value: 'left'
			}, {
				label: 'Center',
				value: 'center'
			}, {
				label: 'Right',
				value: 'right'
			}],
			default: 'left'
		}].concat(_toConsumableArray(cellSizes(key, sizeDefault)))
	};
};

exports.default = function (node) {
	return {
		type: 'SKU_TABLE',
		name: 'Article Variants Table',
		allowedSections: ['footer', 'header', 'main'],
		disallowedChildren: ['*'],
		category: 'Article',
		styleClasses: {},
		props: [{
			label: 'Use current article',
			name: 'useArticleInState',
			inputType: 'checkbox',
			default: true
		}, node && !node.props.useArticleInState && {
			label: 'Article Link Name',
			name: 'articleLFNQuery',
			inputType: 'text',
			default: 'my_article'
		}, {
			label: 'Show Headings',
			name: 'showHeadings',
			inputType: 'checkbox',
			default: true
		}, {
			label: 'Buyable',
			name: 'buyable',
			inputType: 'checkbox',
			default: true
		}, node && node.props.buyable && {
			label: 'Only buyable when logged in',
			name: 'buyableLoggedIn',
			inputType: 'checkbox',
			default: false
		}, node && node.props.buyableLoggedIn && {
			label: 'Always show price',
			name: 'alwaysShowPrice',
			inputType: 'checkbox',
			default: false
		}, node && node.props.buyable && {
			label: 'Buy button text',
			name: 'buyButtonText',
			inputType: 'text',
			default: 'Add to cart'
		}, node && node.props.buyable && {
			label: 'Feedback message display',
			name: 'feedbackDisplayType',
			inputType: 'select',
			values: [{
				label: 'Attributes',
				value: 'attributes'
			}, {
				label: 'PLU-Number',
				value: 'pluno'
			}, {
				label: 'EAN13',
				value: 'ean13'
			}],
			default: 'attributes'
		}].filter(Boolean),
		hiddenProps: [getField('media', 'Thumbnail', '', 1, '1of12'), getField('artname', 'Name', 'Name', 2, '2of12'), getField('artno', 'Product Number', 'ArtNo.', 3, '2of12'), getField('ean13', 'EAN13', 'EAN13', 4, null, false), getField('pluno', 'PLU', 'PLU-Number', 5, null, false), getField('attr1', 'Attribute 1', 'Color', 6, '1of12'), getField('attr2', 'Attribute 2', 'Size', 7, '1of12'), getField('attr3', 'Attribute 3', 'Color', 8, '1of12', false), getField('price', 'Price', 'Price', 9, '1of12'), getField('qty', 'Quantity', 'Quantity', 10, '2of12')]

	};
};

var fields = exports.fields = ['artno', 'artname', 'ean13', 'pluno', 'attr1', 'attr2', 'attr3', 'media', 'price', 'qty'];